if (!customElements.get('brienor-footer-menu')) {
  customElements.define('brienor-footer-menu', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.media = window.matchMedia('(min-width: 750px)');
      this.sync = () => {
        this.details.open = this.media.matches;
        this.summary.tabIndex = this.media.matches ? -1 : 0;
      };
      this.preventDesktopToggle = (event) => {
        if (this.media.matches) event.preventDefault();
      };
      this.media.addEventListener('change', this.sync);
      this.summary.addEventListener('click', this.preventDesktopToggle);
      this.sync();
    }
    disconnectedCallback() {
      this.media.removeEventListener('change', this.sync);
      this.summary.removeEventListener('click', this.preventDesktopToggle);
    }
  });
}
